
const grey = '#555555'
const lightgrey = '#aaaaaa'

const themes = [
  {   //Theme 0
    primary:            '#c30017', // red
    primary_light:      '#f8001d',
    primary_lighter:    '#fd102c',
    primary_dark:       '#fb000e',
    primary_darker:     '#0b0001',

    secondary:          '#cb5200', // orange
    secondary_light:    '#ff6700',
    secondary_lighter:  '#ff7110',
    secondary_dark:     '#803400',
    secondary_darker:   '#0c0500',

    tertiary:           '#9b0068', // purple
    tertiary_light:     '#d90092',
    tertiary_lighter:   '#f510aa',
    tertiary_dark:      '#620042',
    tertiary_darker:    '#090006',

    quaternary:         '#24ab00', // green
    quaternary_light:   '#30e500',
    quaternary_lighter: '#40f810',
    quaternary_dark:    '#166c00',
    quaternary_darker:  '#020a00',

    grey:               grey,
    grey_light:         lightgrey,
  },
]


export {
  themes
}